import classNames from 'classnames';
import { useSearchParams } from 'wouter';
import SortingIcon from './SortingIcon';

import styles from './Sorting.module.scss';

const Sorting = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const sort = searchParams.get('sort');

  const onSortChangeHandler = () => {
    setSearchParams(
      (prev) => {
        const currentSort = prev.get('sort');

        if (!currentSort) {
          prev.set('sort', 'asc');
        } else if (currentSort === 'asc') {
          prev.set('sort', 'desc');
        } else if (currentSort === 'desc') {
          prev.delete('sort');
        }

        return prev;
      },
      { replace: true },
    );
  };

  return (
    <button
      className={classNames(styles['sorting-button'], {
        [styles.active]: sort,
      })}
      type="button"
      onClick={onSortChangeHandler}
    >
      A-Z <SortingIcon />
    </button>
  );
};

export default Sorting;
